
interface EmptyStateProps {
  icon?: string
  title: string
  subtitle?: string
}

export function EmptyState({ icon, title, subtitle }: EmptyStateProps) {
  return (
    <div className="empty-state fu">
      {icon && <div className="empty-icon">{icon}</div>}
      <div>{title}</div>
      {subtitle && (
        <div style={{ fontFamily: 'var(--mono)', fontSize: '0.7rem', color: 'var(--text3)', maxWidth: 440, textAlign: 'center' }}>
          {subtitle}
        </div>
      )}
    </div>
  )
}

export function PageLoading({ message = 'Loading…' }: { message?: string }) {
  return (
    <div className="empty-state">
      <span className="spinner" />
      <p style={{ marginTop: 8, fontSize: '0.85rem', color: 'var(--text2)' }}>{message}</p>
    </div>
  )
}
